import { useMutation } from '@apollo/client';
import { BasicPricingTaxi, CreateBasicPricingTaxiInput } from '../../shared/types';
import { CreateBasicTaxiPricingResponse, CreateBasicTaxiPricingRequest, CITRIN_CREATE_BASIC_TAXI_PRICING } from '..';

type CreateMutationFunction = (request: CreateBasicPricingTaxiInput) => Promise<BasicPricingTaxi>;
export const useCreateBasicTaxiPricingMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateBasicTaxiPricingResponse, CreateBasicTaxiPricingRequest>(
        CITRIN_CREATE_BASIC_TAXI_PRICING
    );
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createBasicTaxiPricing;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
